import React, { useRef } from 'react';
import { MenuCard } from './MenuCard';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { FriesIcon } from './SectionIcons';
export function Extras() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="w-full bg-bp-bg py-20 px-6 md:px-20 border-t border-bp-line" data-id="element-29">
      <div className="max-w-container mx-auto" data-id="element-30">
        <motion.div ref={ref} className="flex flex-col items-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-31">
          <FriesIcon className="mb-4" data-id="element-32" />
          <h2 className="font-display text-[32px] md:text-[48px] leading-none text-bp-text tracking-[0.1em] uppercase text-center" data-id="element-33">
            EXTRAS
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-34">
          <MenuCard name="COMBO" price="+6.000" ingredients={['Papas fritas artesanales.', 'Cualquier bebida del menú.']} delay={0} data-id="element-35" />

          <MenuCard name="PAPAS FRITAS ARTESANALES" price="4.000" ingredients={['120 g']} delay={0.1} data-id="element-36" />
        </div>
      </div>
    </section>;
}